/* SAMPLES:
//////////////////////////////////////////////////////////////////////////////////////////////
//Minimum usable sample:

    UI.message.show({
        header: 'header text',
        body: messageBodyDraw
    });

    UI.message.hide();

//////////////////////////////////////////////////////////////////////////////////////////////
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { PopUp } from "../PopUp";
var UI = window["UI"] || {};
var UIMessage = /** @class */ (function () {
    function UIMessage() {
        this.popupStack = [];
    }
    /**
     * Show specific UI message on screen with passed config
     * @param {UIMessageConfig} config UI message configuration
     * @param {string} id UI message id to show
     */
    UIMessage.prototype.show = function (config, id) {
        var msgStackContainer = document.getElementById("rj-popup-message-root") || document.body;
        var popupInfo = id ? this.popupStack.find(function (p) { return p.id === id && typeof id === "string"; }) : undefined;
        var popup;
        if (!popupInfo) {
            popup = new PopUp(config, msgStackContainer, this.removeFromStack.bind(this, id));
            this.popupStack.push({ id: id, popup: popup });
        }
        else {
            popup = popupInfo.popup;
        }
        popup.show();
        this.popupStack.forEach(function (p) { p.popup.msgContainer.classList.add("hidden"); });
        popup.msgContainer.classList.remove("hidden");
        return popup;
    };
    /**
     * Hide UI message with specific id if present or the last one
     * @param {string} id UI message id to hide
     */
    UIMessage.prototype.hide = function (id) {
        var popupInfo = id
            ? this.popupStack.find(function (p) { return p.id === id && typeof id === "string"; })
            : this.popupStack[this.popupStack.length - 1];
        if (popupInfo) {
            popupInfo.popup.hide();
        }
        return this.popupStack;
    };
    /**
     * Remove UI message with specific id or the last one.
     * @param {string} id UI message id to remove
     */
    UIMessage.prototype.removeFromStack = function (id) {
        if (this.popupStack.length === 0) {
            return this.popupStack;
        }
        var popupInfoIndex = id ? this.popupStack.findIndex(function (i) { return i.id === id && typeof id === "string"; }) : -1;
        if (popupInfoIndex > -1) {
            var popupToRemove = __assign({}, this.popupStack[popupInfoIndex]);
            this.popupStack.splice(popupInfoIndex, 1);
            this.popupStack.push(popupToRemove);
        }
        this.popupStack[this.popupStack.length - 1].popup.msgStackContainer.removeChild(this.popupStack[this.popupStack.length - 1].popup.msgContainer);
        this.popupStack.pop();
        this.popupStack.length > 0 && this.popupStack[this.popupStack.length - 1].popup.msgContainer.classList.remove("hidden");
        return this.popupStack;
    };
    return UIMessage;
}());
export { UIMessage };
UI["message"] = new UIMessage();
// override default alert function to use UI.message.show behavior
function alert(message) {
    "use strict";
    UI.message.show({
        body: message,
        actions: {
            cancel: { text: "OK", focus: true },
        }
    });
}
Window.prototype.alert = window.alert = alert;
export var ui = UI;
window["UI"] = UI;
//# sourceMappingURL=UIMessage.js.map